export default __webpack_public_path__ + "static/media/gender.16ecee05.svg";